import { render } from "./WithdrawalForm.vue?vue&type=template&id=be08064e&ts=true"
import script from "./WithdrawalForm.vue?vue&type=script&lang=ts"
export * from "./WithdrawalForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__